import PropTypes from "prop-types";

const StripeProps = PropTypes.shape({
  confirmCardPayment: PropTypes.func.isRequired,
  createPaymentMethod: PropTypes.func.isRequired,
});

export default StripeProps;
